
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/journal/post/[countryCode]/[smartBanner]/[ampValue]/[slug]",
      function () {
        return require("private-next-pages/[lang]/journal/post/[countryCode]/[smartBanner]/[ampValue]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/journal/post/[countryCode]/[smartBanner]/[ampValue]/[slug]"])
      });
    }
  